import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';

const TARGET_TIMESTAMP = Date.UTC(2025, 10, 23, 8, 0, 0); // 23 Nov 2025 08:00 UK time (GMT)

const formatRemainingTime = (milliseconds) => {
  const totalSeconds = Math.max(Math.floor(milliseconds / 1000), 0);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return { days, hours, minutes, seconds };
};

function CountdownOverlay({ isVisible }) {
  const [timeLeft, setTimeLeft] = useState(() =>
    Math.max(TARGET_TIMESTAMP - Date.now(), 0)
  );
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 640);

  useEffect(() => {
    if (!isVisible) return;
    const interval = setInterval(() => {
      setTimeLeft(Math.max(TARGET_TIMESTAMP - Date.now(), 0));
    }, 1000);
    return () => clearInterval(interval);
  }, [isVisible]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 640);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const hasElapsed = timeLeft <= 0;
  const formatted = useMemo(() => formatRemainingTime(timeLeft), [timeLeft]);

  if (!isVisible || hasElapsed) {
    return null;
  }

  return (
    <div className="countdown-overlay" role="dialog" aria-modal="true">
      <div className="countdown-overlay__content">
        <p className="countdown-overlay__eyebrow"></p>
        <h2>Opens Sunday, 23 November 2025 at 08:00 (UK)</h2>
        <p className="countdown-overlay__message">
        </p>
        <div className="countdown-overlay__timer" aria-live="polite">
          <div>
            <span>{formatted.days}</span>
            <label>Days</label>
          </div>
          <div>
            <span>{formatted.hours.toString().padStart(2, '0')}</span>
            <label>Hours</label>
          </div>
          <div>
            <span>{formatted.minutes.toString().padStart(2, '0')}</span>
            <label>{isMobile ? 'min' : 'Minutes'}</label>
          </div>
          <div>
            <span>{formatted.seconds.toString().padStart(2, '0')}</span>
            <label>{isMobile ? 's' : 'Seconds'}</label>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CountdownOverlay;
